import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Checkbox, FormControlLabel, Box } from "@mui/material";

import { ContainerBg, StyledTable } from "../../useGeneralStyles";
import { APIJourneys } from "../../api";
import { IJourney } from "../../api/journeys/index.types";

import { ContainerWithLoader, PaginationWithLimit } from "../../components/ui";
import usePagination from "../../hooks/usePagination";
import { setPage } from "../../utils";
import { useAuthContext } from "../../context";

const Journeys = (): React.ReactElement => {
  const { hasExpired } = useAuthContext();
  const history = useHistory();
  const pagination = usePagination();

  const [journeys, setJourneys] = useState<IJourney[]>([]);
  const [isLoading, setLoading] = useState(true);
  const [isShowInactiveJourneys, setIsShowInactiveJourneys] = useState(false);

  const handleClickJourney = (id: number) => history.push(`journeys/${id}`);
  const handleShowInactiveJourneys = () => setIsShowInactiveJourneys(!isShowInactiveJourneys);
  const handleSetPage = (value: number) =>
    setPage(value, pagination.count, +pagination.limit, pagination.setPage);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await APIJourneys.getJourneysList({
          limit: pagination.limit,
          page: pagination.page,
          contains: {
            isShowInactiveJourneys,
          },
        });
        setJourneys(data.journeys);
        pagination.setCount(data.count);
      } catch (error) {
        console.error("Error fetching journeys list", error);
        hasExpired();
      } finally {
        setLoading(false);
      }
    })();
  }, [pagination.page, pagination.limit, isShowInactiveJourneys]);

  return (
    <div>
      <h2>Journeys</h2>
      <ContainerBg sx={{ overflow: "scroll" }}>
        <ContainerWithLoader isLoading={isLoading} report={journeys}>
          <StyledTable>
            <thead>
              <tr>
                <td>Id</td>
                <td>Name</td>
                <td>Description</td>
              </tr>
            </thead>
            <tbody>
              {journeys.map(({ id, name, description }) => (
                <tr key={id} onClick={() => handleClickJourney(id)}>
                  <td>{id}</td>
                  <td>{name}</td>
                  <td>{description}</td>
                </tr>
              ))}
            </tbody>
          </StyledTable>
        </ContainerWithLoader>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <PaginationWithLimit
            count={pagination.count}
            limit={pagination.limit}
            page={pagination.page}
            setPageState={handleSetPage}
            setLimit={pagination.setLimit}
          />
          <FormControlLabel
            label="Show inactive journeys"
            control={
              <Checkbox
                checked={isShowInactiveJourneys}
                onChange={handleShowInactiveJourneys}
                name="inactiveAccounts"
              />
            }
          />
        </Box>
      </ContainerBg>
    </div>
  );
};

export default Journeys;
